// Story slider on story detail page (4 latest stories)

import mediaLazyLoad from '../utils/rbata.mediaLazyLoad';

const storyDetailSlider = {
    sliderSelector:   '.story-module__slider-container',
    $sliderContainer: $('.story-module__slider'),
    slider:           null,
    buildSlider() {
        this.slider = tns({
            container:            this.sliderSelector,
            mode:                 'carousel',
            items:                1,
            controls:             true,
            nav:                  false,
            arrowKeys:            true,
            speed:                1000,
            autoplay:             false,
            autoplayButton:       false,
            autoplayButtonOutput: false,
            lazyload:             false,
            mouseDrag:            true,
            loop:                 false,
            prevButton:           this.$sliderContainer.find('.story-module__slider-left')[0],
            nextButton:           this.$sliderContainer.find('.story-module__slider-right')[0],
            responsive:           {
                1200: {
                    items:  2,
                    gutter: 0
                },
                684:  {
                    gutter: 28
                }
            },
            onInit:               () => {
                this.$sliderContainer.removeClass('cms-storyslider__stories--not-initialized');
                this.initNav();
                mediaLazyLoad.refreshLazyLoad();
            }
        });
    },
    updateArrows(sliderEvent) {
        const arrowPrev = storyDetailSlider.$sliderContainer.find('.story-module__slider-left');
        const arrowNext = storyDetailSlider.$sliderContainer.find('.story-module__slider-right')
        const hideArrowSlideNum = sliderEvent.items === 1 ? sliderEvent.slideCount : sliderEvent.slideCount - 1;
        arrowPrev.removeClass('d-none');
        arrowNext.removeClass('d-none');

        if (hideArrowSlideNum === sliderEvent.displayIndex) {
            arrowNext.addClass('d-none');
        }
        if (sliderEvent.displayIndex === 1) {
            arrowPrev.addClass('d-none');
        }
    },

    initNav() {
        this.$sliderContainer.find('.story-module__slider-left').addClass('d-none');
        setTimeout(() => {
            this.slider.events.on('indexChanged', this.updateArrows);
        })
    }
};

// DOM ready
$(() => {
    if (storyDetailSlider.$sliderContainer.length) {
        storyDetailSlider.buildSlider();
    }
});


